import { HsaQuestionType } from "@redotech/redo-conversion-hsa-common/hsa-question-type";
import { t } from "@redotech/redo-i18n";

export function hsaQuestionTypeLabels(): Record<HsaQuestionType, string> {
  return {
    [HsaQuestionType.AGE_INPUT_QUESTION]: t("Age"),
    [HsaQuestionType.EMAIL_INPUT_QUESTION]: t("Email"),
    [HsaQuestionType.TEXT_INPUT_QUESTION]: t("Text"),
    [HsaQuestionType.DATE_INPUT_QUESTION]: t("Date"),
    [HsaQuestionType.PHONE_INPUT_QUESTION]: t("Phone"),
    [HsaQuestionType.SINGLE_SELECT_RADIO_QUESTION]: t("Single choice"),
    [HsaQuestionType.SINGLE_SELECT_DROPDOWN_QUESTION]: t("Dropdown"),
    [HsaQuestionType.SINGLE_SELECT_OTHER_QUESTION]: t(
      "Single choice with write-in",
    ),
    [HsaQuestionType.MULTI_SELECT_QUESTION]: t("Multiple choice"),
    [HsaQuestionType.MULTI_SELECT_NONE_QUESTION]: t(
      "Multiple choice with none",
    ),
    [HsaQuestionType.DYNAMIC_MULTI_SELECT_QUESTION]: t(
      "Multiple choice (dynamic)",
    ),
  };
}
